import { render, staticRenderFns } from "./BlogDetails.vue?vue&type=template&id=7dcbc3bc&scoped=true"
import script from "./BlogDetails.vue?vue&type=script&lang=js"
export * from "./BlogDetails.vue?vue&type=script&lang=js"
import style0 from "./BlogDetails.vue?vue&type=style&index=0&id=7dcbc3bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcbc3bc",
  null
  
)

export default component.exports